export const REPORTING_FIELDS = {
  C_LEVEL: 'cLevel',
  DIRECTOR: 'director',
  MANAGER: 'manager',
  TEAM_LEADER: 'teamLeader'
}

export const HIERARCHY_TIERS = {
  C_LEVEL: 'cLevel',
  DIRECTOR: 'director',
  MANAGER: 'manager'
}

const MANAGER_VISIBLE_LEVELS = [3, 4, 6, 7, 8]
const TEAM_LEADER_VISIBLE_LEVELS = [4, 7]

function isVisibleByUserLevel(field, userLevel) {
  const level = Number(userLevel)

  switch (field) {
    case REPORTING_FIELDS.C_LEVEL:
      return true
    case REPORTING_FIELDS.DIRECTOR:
      return level !== 1
    case REPORTING_FIELDS.MANAGER:
      return MANAGER_VISIBLE_LEVELS.includes(level)
    case REPORTING_FIELDS.TEAM_LEADER:
      return TEAM_LEADER_VISIBLE_LEVELS.includes(level)
    default:
      return false
  }
}

function isVisibleByHierarchyTier(field, hierarchyTier) {
  if (hierarchyTier === HIERARCHY_TIERS.C_LEVEL) {
    return false
  }

  if (hierarchyTier === HIERARCHY_TIERS.DIRECTOR) {
    return field === REPORTING_FIELDS.C_LEVEL
  }

  if (hierarchyTier === HIERARCHY_TIERS.MANAGER) {
    return field === REPORTING_FIELDS.C_LEVEL || field === REPORTING_FIELDS.DIRECTOR
  }

  return null
}

export function isReportingFieldVisible(field, userLevel, { hierarchyTier = null } = {}) {
  if (hierarchyTier) {
    return isVisibleByHierarchyTier(field, hierarchyTier)
  }

  return isVisibleByUserLevel(field, userLevel)
}

function toReportingValue(value, visible) {
  if (!visible) {
    return null
  }

  return value || null
}

export function buildReportingFieldsPayload(
  userLevel,
  { c_level_selected, project_manager_selected, managerSelected, teamLeaderSelected },
  options = {}
) {
  return {
    c_level: toReportingValue(
      c_level_selected,
      isReportingFieldVisible(REPORTING_FIELDS.C_LEVEL, userLevel, options)
    ),
    has_project_manager: toReportingValue(
      project_manager_selected,
      isReportingFieldVisible(REPORTING_FIELDS.DIRECTOR, userLevel, options)
    ),
    manager: toReportingValue(
      managerSelected,
      isReportingFieldVisible(REPORTING_FIELDS.MANAGER, userLevel, options)
    ),
    teamleader: toReportingValue(
      teamLeaderSelected,
      isReportingFieldVisible(REPORTING_FIELDS.TEAM_LEADER, userLevel, options)
    )
  }
}

export function getHiddenReportingFieldKeys(userLevel, options = {}) {
  const hidden = {}

  if (!isReportingFieldVisible(REPORTING_FIELDS.C_LEVEL, userLevel, options)) {
    hidden.c_level_selected = ''
  }
  if (!isReportingFieldVisible(REPORTING_FIELDS.DIRECTOR, userLevel, options)) {
    hidden.project_manager_selected = ''
  }
  if (!isReportingFieldVisible(REPORTING_FIELDS.MANAGER, userLevel, options)) {
    hidden.managerSelected = ''
  }
  if (!isReportingFieldVisible(REPORTING_FIELDS.TEAM_LEADER, userLevel, options)) {
    hidden.teamLeaderSelected = ''
  }

  return hidden
}

export function filterHierarchyDropdownUsers(users, editedUserId) {
  if (!editedUserId) {
    return users
  }

  const editedId = String(editedUserId)
  return (users || []).filter((user) => String(user._id) !== editedId)
}
